import { View, Button, Text, Flex, TruncateText, Responsive, Tooltip } from "@instructure/ui"

const StudentPreviewFooter = ({ itemName, itemType, standard, points }) => {

    const t = window._t;

    const handleRestartClick = () => {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const materialId = params.get('material_id');

        const domain = window.MC_ENV.origins.app.replace("{root_domain}", MC_ENV.root_domain);
        const url = `${domain}/materials/${materialId}/preview/answers/reset`;

        fetch(url, {
            method: 'POST',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(_data => {
                window.location.reload(true);
            });
    }

    const handleCloseClick = () => window.close();

    return (
        <View as="div" position="sticky" bottom='0' left='0' width="100%" height="4rem" alignItems="center">
            <Responsive
                match="media"
                display="flex"
                query={{
                    small: { maxWidth: 640 },
                    medium: { minWidth: 641, maxWidth: 1279 },
                    large: { minWidth: 1280 }
                }}
            >
                {(_responsiveProps, matches) => {
                    if (!itemType) {
                        console.warn("StudentPreviewFooter: itemType is required, but not provided. Footer will not render.", {itemType, standard, points});
                        return null;
                    }

                    const isMobile = matches.includes("small");
                    const isTablet = matches.includes("medium");
                    const isLarge = matches.includes("large");

                    return (
                        <Flex as="div" direction="row" width="100%" wrap="nowrap" alignItems="center" gap="small">
                            {isMobile ? null : (
                                <Flex.Item shouldShrink overflowX="hidden">
                                    <Flex alignItems="center" gap="small" wrap="nowrap">
                                        {itemName ? (
                                            <>
                                                <MetaDataItem label={itemName} showValue={false} isTablet={isTablet} isLarge={isLarge} />
                                                <MetaDataSeparator />
                                            </>
                                        ) : null}
                                        <MetaDataItem label={t("Item Type")} value={itemType} isTablet={isTablet} isLarge={isLarge} />
                                        <MetaDataSeparator />
                                        <MetaDataItem label={t("Standard")} value={standard} isTablet={isTablet} isLarge={isLarge} />
                                        <MetaDataSeparator />
                                        <MetaDataItem label={t("Points")} value={points} isTablet={isTablet} isLarge={isLarge} />
                                    </Flex>
                                </Flex.Item>
                            )}

                            <Flex.Item shouldGrow shouldShrink={false}>
                                <Flex justifyItems={isMobile ? "space-between" : "end"} alignItems="center">
                                    <Flex.Item>
                                        <Button color="secondary" margin="small" onClick={handleRestartClick}>{t("Restart")}</Button>
                                    </Flex.Item>
                                    <Flex.Item>
                                        <Button color="primary" margin="small" onClick={handleCloseClick}>{t("Close view")}</Button>
                                    </Flex.Item>
                                </Flex>
                            </Flex.Item>
                        </Flex>
                    );
                }}
            </Responsive>
        </View>
    )
}

const MetaDataItem = ({ label, value, showValue = true, isTablet, isLarge }) => {
    return (
        <Flex.Item shouldGrow={isTablet} size={isTablet ? "150px" : "auto"}>
            <View as="div" padding="small">
                {
                    showValue ? (
                        <Tooltip as="div" renderTip={`${label}: ${value}`}>
                            <TruncateText>
                                <Text>
                                    <Text weight="bold">{isLarge ? `${label}: ` : ""}</Text>{`${value}`}
                                </Text>
                            </TruncateText>
                        </Tooltip>

                    ) : (
                        <Tooltip as="div" renderTip={label}>
                            <TruncateText>
                                <Text weight="bold">
                                    {label}
                                </Text>
                            </TruncateText>
                        </Tooltip>
                    )
                }
            </View>
        </Flex.Item>
    )
}

const MetaDataSeparator = () => {
    return (
        <Flex.Item>
            <Text>|</Text>
        </Flex.Item>
    )
}

export { StudentPreviewFooter }